import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {ensureOk, request} from "../apiUtils";

export function useLogoutMutation(): UseMutationResult<void, Error, void> {
    return useMutation({
        mutationFn: async () => {
            const response = await request("/logout", {
                method: "POST",
            });
            await ensureOk(response);
        },
    });
}
